/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button } from "@mui/material";
import * as React from 'react';
import Dropzone from 'react-dropzone';
import { base64ToBlob } from '../common/common';
import "./styles.css";
interface Props {
  onDrop: Function
  selectedPdf: any
}
interface State {
  selectedPdf: any
}
class DragDrop extends React.Component <Props,State>{
  state = {
    selectedPdf: undefined
  };
  componentDidMount() {
    if (this.props.selectedPdf !== undefined){
      this.setState({ selectedPdf: this.props.selectedPdf instanceof Blob ? URL.createObjectURL(this.props.selectedPdf) : this.props.selectedPdf });
    }
  }
  onDrop = (files: any) => {
    if (files.length) {
      const currentFile = files[0];
      const reader = new FileReader();
      let a: any = undefined;
      reader.addEventListener('load', () => {
        a = reader.result;
        if (a != null) {
          const b = a.split(',')[1];
          const blob = base64ToBlob(b, 'application/pdf');
          const url = URL.createObjectURL(blob);
          this.setState({
            selectedPdf: url
          }, () => {
              this.props.onDrop(blob, currentFile.name);
          });
        }
      }, false);

      reader.readAsDataURL(currentFile);
    }    
  };
  render() {
    const { selectedPdf } = this.state;
    return (
      selectedPdf === undefined ?
        <div className="text-center dropZone">
          <Dropzone onDrop={this.onDrop} accept={{ 'application/pdf': ['.pdf'] }}>
          {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()}>
                <input {...getInputProps()} />
             
                <div>
                <p> Drag & Drop file here </p>
                <p>(or)</p>
                <Button className="uploadFromComputer">Upload from computer</Button>
              </div>
                
              
            </div>
          )}
        </Dropzone>
        </div>
        :
        <object data={selectedPdf} type="application/pdf" className="dragDropPdfBox">
          <embed src={selectedPdf} type="application/pdf" />
        </object>
    );
  }
}

export default DragDrop;
